import styled from 'styled-components'

export const ConnectorContainer = styled.div`
  height: 2px;
  width: 30rem;
  background: #ecece2;
`
